"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("@material-ui/core/utils");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var warning_1 = __importDefault(require("warning"));
var Collapse_1 = require("../Collapse");
// import { CompactAccordionSummaryProps } from '../CompactAccordionSummary'
var Paper_1 = require("../Paper");
var styles_1 = require("../styles");
// Workaround https://github.com/jsdom/jsdom/issues/2026
var edgeFix = typeof window !== 'undefined' && /jsdom/.test(window.navigator.userAgent)
    ? {}
    : {
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        },
    };
var styles = function (theme) { return ({
    root: {
        position: 'relative',
        transition: theme.transitions.create(['margin'], { duration: theme.transitions.duration.shortest }),
        '&:before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: theme.palette.divider,
            transition: theme.transitions.create(['opacity', 'background-color'], { duration: theme.transitions.duration.shortest }),
        },
        '&:first-child': {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            '&:before': {
                display: 'none',
            },
        },
        '&:last-child': __assign({ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }, edgeFix),
        '&$expanded + &': {
            '&:before': {
                display: 'none',
            },
        },
    },
    expanded: {
        margin: '0',
        '&:first-child': {
            marginTop: 0,
        },
        '&:last-child': {
            marginBottom: 0,
        },
        '&:before': {
            opacity: 0,
        },
    },
    disabled: {
        backgroundColor: theme.palette.action.disabledBackground,
    },
}); };
var UnstyledCompactAccordion = /** @class */ (function (_super) {
    __extends(UnstyledCompactAccordion, _super);
    function UnstyledCompactAccordion(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.handleChange = function (event) {
            var expanded = _this.isControlled
                ? _this.props.expanded
                : _this.state.expanded;
            if (!_this.isControlled) {
                _this.setState({ expanded: !expanded });
            }
            if (_this.props.onChange) {
                _this.props.onChange(event, !expanded);
            }
        };
        // eslint-disable-next-line eqeqeq
        _this.isControlled = props.expanded != null;
        if (!_this.isControlled) {
            // not controlled, use internal state
            _this.state.expanded =
                props.defaultExpanded !== undefined ? props.defaultExpanded : false;
        }
        return _this;
    }
    UnstyledCompactAccordion.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, childrenProp = _b.children, classes = _b.classes, classNameProp = _b.className, CollapsePropsProp = _b.CollapseProps, defaultExpanded = _b.defaultExpanded, disabled = _b.disabled, expandedProp = _b.expanded, onChange = _b.onChange, other = __rest(_b, ["children", "classes", "className", "CollapseProps", "defaultExpanded", "disabled", "expanded", "onChange"]);
        var expanded = this.isControlled ? expandedProp : this.state.expanded;
        var className = (0, clsx_1.default)(classes.root, (_a = {},
            _a[classes.expanded] = expanded,
            _a[classes.disabled] = disabled,
            _a), classNameProp);
        var summary = null;
        var children = react_1.Children.map(childrenProp, function (child) {
            if (!(0, react_1.isValidElement)(child)) {
                return null;
            }
            (0, warning_1.default)(child.type !== react_1.Fragment, [
                'Material-UI: the CompactAccordion component doesn\'t accept a Fragment as a child.',
                'Consider providing an array instead.',
            ].join('\n'));
            if ((0, utils_1.isMuiElement)(child, ['CompactAccordionSummary'])) {
                // summary = cloneElement<CompactAccordionSummaryProps>(child, {
                summary = (0, react_1.cloneElement)(child, {
                    disabled: disabled,
                    expanded: expanded,
                    onChange: _this.handleChange,
                });
                return null;
            }
            return child;
        });
        var CollapseProps = !expanded
            ? {
                'aria-hidden': 'true',
            }
            : null;
        return (react_1.default.createElement(Paper_1.Paper, __assign({ className: className, elevation: 1, square: true }, other),
            summary,
            react_1.default.createElement(Collapse_1.Collapse, __assign({ in: expanded, timeout: "auto" }, CollapseProps, CollapsePropsProp), children)));
    };
    UnstyledCompactAccordion.defaultProps = {
        defaultExpanded: false,
        disabled: false,
    };
    return UnstyledCompactAccordion;
}(react_1.Component));
var CompactAccordion = (0, styles_1.withStyles)(styles, { name: 'CompactAccordion' })(UnstyledCompactAccordion);
exports.default = CompactAccordion;
//# sourceMappingURL=CompactAccordion.js.map